import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ws_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function saveToken(token) {
  localStorage.setItem("ws_admin_token", token);
}
export function clearToken() {
  localStorage.removeItem("ws_admin_token");
}
export function getToken() {
  return localStorage.getItem("ws_admin_token");
}

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ein Fehler ist aufgetreten";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  return String(d);
}
